import Dashboard from "../../components/views/dashboard/Dashboard.vue";
import DashboardStats from "../../components/views/dashboard/DashboardStats.vue";
import DeniedDetails from "../../components/views/dashboard/DeniedDetails.vue";
import DashboardInvitations from "@/components/views/dashboard/DashboardInvitations.vue";
import Login from "../../components/views/Login.vue";


export default [
  {
    path: '/', component: Login,
  },
  {
    path: '/dashboard', component: Dashboard,
    children: [
      {
        path: '',
        component: DashboardStats,
        name: 'general_stats'
      },
      {
        path: 'denied',
        component: DeniedDetails,
        name: 'denied_details'
      },
      {
        path: 'invitations',
        component: DashboardInvitations,
        name: 'dashboard_invitations'
      }
    ],
    meta: {requiresAuth: true}
  },
]
